import { useSettings } from "../Clubs/hooks";
import { Blockquote } from "@ui";
import { Trans, useTranslation } from "react-i18next";

interface Props {
    clubSlug?: string;
    active?: boolean;
}

const MollieConnectFeeWarning = ({ clubSlug, active = true }: Props) => {
    const { t } = useTranslation("general");
    const [mollieSettings] = useSettings("mollie", clubSlug);
    const hasCancellationFees = mollieSettings?.cancellation_fee?.active;

    if (!hasCancellationFees || !active) {
        return null;
    }

    return (<Blockquote color="warning" className="!tw-mt-0 !tw-mb-4">
            <h5 className="tw-font-semibold">{t("mollie.feeWarning.title")}</h5>
            <p className="tw-mb-0">
                <Trans
                    t={t}
                    i18nKey="mollie.feeWarning.text"
                    values={{
                        amount: mollieSettings.cancellation_fee.value,
                        unit: mollieSettings.cancellation_fee.percentage ? "%" : "€"
                    }}
                    components={{ amount: <span className="tw-font-bold tw-underline" /> }}
                />
            </p>
        </Blockquote>
    );
};

export default MollieConnectFeeWarning;